// 百信银行数据管理API
import axios from "@/libs/api.request";

export const getList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/platform_data/getImportRecords',
        params: data,
        method: 'get'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const importData = async (that, data) => {
    var res = await axios.request({
        url: '/shop/platform_data/importExcel',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getAccounts = async (that, data) => {
    var res = await axios.request({
        url: '/shop/platform_data/getAccounts',
        params: data,
        method: 'get'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getCities = async (that, data) => {
    var res = await axios.request({
        url: '/shop/platform_data/getCities',
        params: data,
        method: 'get'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getStatistics = async (that, data) => {
    var res = await axios.request({
        url: '/shop/platform_data/getStatistics',
        params: data,
        method: 'get'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}